import styled, { css } from "styled-components"

import StatefulField from "shared/components/StatefulField"

const StatefulInputWithLinethrough = styled(StatefulField.Input)<{ linethrough?: boolean }>`
  input {
    ${({ linethrough }) =>
      linethrough === true &&
      css`
        text-decoration: line-through;
        &:focus {
          text-decoration: none;
        }
      `}
  }
`

export default StatefulInputWithLinethrough
